import LocalStorage from "utils/LocalStorage";
import api from "Services/API";
import { ENDPOINTS } from "../Endpoints";

const renewToken = () => {
    return api.post<{ access_token: string; refresh_token: string }>(
        "/auth/refresh",
        {
            refresh_token: LocalStorage.getRefreshToken(),
        }
    );
};

export const getTotpQrCode = () => {
    return api.get<{ url: string }>(ENDPOINTS.TOTP_QR);
};

const logout = () => {
    localStorage.clear();
    window.location.href = "/";
};

const AuthService = {
    renewToken,
    logout,
};

export default AuthService;
